import { SettingConfig } from "./SettingConfig";
import { useMemo } from "react";
import { NonNullableSettingConfig } from "./NonNullableSettingConfig";

export const useMemoizeSettingConfig = <TValue>(
  settingConfig: SettingConfig<TValue>
): SettingConfig<TValue> => {
  return useMemo(
    () => settingConfig,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [settingConfig.constructor, settingConfig.type]
  );
};

export const useMemoizeNoNullableSettingConfig = <TValue>(
  settingConfig: NonNullableSettingConfig<TValue>
): NonNullableSettingConfig<TValue> => {
  return useMemo(
    () => settingConfig,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [settingConfig.constructor, settingConfig.type]
  );
};
